import styled from 'styled-components';
import { LabelRegularBoldM, LabelRegularM } from '../../styles/globals';
import { ITheme } from '../../styles/theme';

interface INotificationCont {
  theme: ITheme;
  backgroundColor?: string;
  borderColor?: string;
  borderRadius?: string;
  borderWidth?: string;
}

export const NotificationCont = styled.div<INotificationCont>`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  ${({ theme, borderColor, backgroundColor, borderRadius, borderWidth }: INotificationCont) => `
       border-radius: ${borderRadius};
       border: solid ${borderColor};
       border-width: ${borderWidth};
       background: ${backgroundColor};
       padding: ${theme.layout.spacing.centy};
       box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
    `};
`;

interface IIconCont {
  theme: ITheme;
  iconColor?: string;
}

export const IconCont = styled.div<IIconCont>`
  width: 24px;
  height: 24px;
  ${({ theme, iconColor }: IIconCont) => `
   svg {
    & path {
      fill: ${iconColor};
    }
  }
    margin: 0 ${theme.layout.spacing.centy} 0 0;
  `};
`;

export const CloseMarkContainer = styled.div`
  position: absolute;
  right: 0;
  cursor: pointer;
  top: 6px;
  right: 6px;
  ${({ theme }: IIconCont) => `
    right: ${theme.layout.spacing.centy};
  `};
`;

interface IExpandableMarkContainer {
  theme: ITheme;
  isExpanded: boolean;
}

export const ExpandableMarkContainer = styled(CloseMarkContainer)<IExpandableMarkContainer>`
  ${({ isExpanded }: IExpandableMarkContainer) => `
      ${!isExpanded ? 'transform: rotate(180deg);' : null}
  `}
`;

export const MessageCont = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

export const MessageTitle = styled(LabelRegularBoldM)`
  display: flex;
  flex-wrap: wrap;
`;

export const MessageDescription = styled(LabelRegularM)`
  display: flex;
  flex-wrap: wrap;
  text-align: start;
  ${({ theme }: IIconCont) => `
    margin-top: ${theme.layout.spacing.nano};
  `};
`;
